import API from '../apiCreate'
import { getHeaders } from '../getHeaders'
import { getParams } from '../getParams'
import axios from 'axios'
import {
  CRMNotificationType,
  FilterLeadParam,
  Lead,
  LeadState,
  RequestCreateAutomation,
  RequestCreateField,
  RequestCreateLead,
  RequestCreateLeadPaymentLink,
  RequestCreateNotification,
  RequestCreateStatus,
  RequestCreateTrigger,
  RequestUpdateAutomation,
  RequestUpdateField,
  RequestUpdateItemsSorting,
  RequestUpdateNotification,
  RequestUpdateStatuses,
  RequestUpdateTrigger,
  ResponseAutomation,
  ResponseAutomations,
  ResponseCheckIsUnused,
  ResponseFields,
  ResponseLead,
  ResponseLeadHistory,
  ResponseLeadPaymentLink,
  ResponseLeadPaymentLinks,
  ResponseLeadPayments,
  ResponseLeads,
  ResponseLeadStatuses,
  ResponseManagers,
  ResponseNotification,
  ResponseNotifications,
  ResponseStatus,
  ResponseStatuses,
  ResponseTrigger,
} from '../types/crm.types'
import {
  EmptyResponse,
  PaginationParam,
  ResponseString,
} from '../types/base.types'
export { API }

export const crmApi = {
  getLeads: (params: {
    status: LeadState
    filter: FilterLeadParam
    paramsPagination: PaginationParam
  }) => API.get<ResponseLeads>(`crm-lead/get-leads/${getParams(params)}`),

  getLead: (params: { lead_id: number }) =>
    API.get<ResponseLead>(`crm-lead/get-lead/${getParams(params)}`),

  getAllManagers: () =>
    API.get<ResponseManagers>('crm-manager/get-all-managers'),
  getAllStatuses: (params: { type: 'client' | 'lead' | 'all' }) =>
    API.get<ResponseStatuses>(`crm-lead-status/get-all-statuses/${getParams(params)}`),
  getAllFields: () => API.get<ResponseFields>('crm-lead-field/get-all-fields'),

  getLeadsByUserId: (params: { user_id: number }) =>
    API.get<ResponseLeads>(`crm-lead/get-leads-by-user-id/${getParams(params)}`),

  // только для админ (и junior-admin конечно же)
  getAllLeadsInExcel: (params: { type: LeadState; filter: FilterLeadParam }) =>
    API.get<BlobPart>(
      `crm-lead-excel/get-all-leads-in-excel/${getParams(params)}`,
      {
        responseType: 'blob',
      },
    ),

  // Изменяет поля type и manager_id у лида
  // (если нету у лида менеджера: если МОП - он берёт только себе лидов, если РОП (админ) - он должен передать manager_id)
  changeLeadsState: (
    params: { type: LeadState; manager_id?: number },
    data: { lead_ids: number[] },
  ) =>
    API.patch<EmptyResponse>(
      `crm-lead/change-leads-state/${getParams(params)}`,
      data,
    ),

  // // только для sales-manager (МОП)
  //   takeLead: (leadId: number) =>
  //     API.post<EmptyResponse>(`crm-manager/take-lead?id=${leadId}`),

  // // только для head-of-sales (РОП) или админ
  //   assignLeadToManager: (params: { lead_id: number; manager_id: number }) =>
  //     API.post<EmptyResponse>(`crm-lead/assign-lead-to-manager/${getParams(params)}`),

  updateLeadFields: (
    params: { lead_id: number },
    data: { fields: { [key: string]: string } },
  ) =>
    API.patch<EmptyResponse>(
      `crm-lead/update-lead-fields/${getParams(params)}`,
      data,
    ),

  updateLead: (
    params: { lead_id: number },
    data: Pick<Lead, 'is_duplicate' | 'user_id'>,
  ) =>
    API.post<EmptyResponse>(`crm-lead/update-lead/${getParams(params)}`, data),

  // только для head-of-sales (РОП) или админ
  removeLeads: (params: { type: LeadState }, data: { lead_ids: number[] }) =>
    API.post<EmptyResponse>(`crm-lead/remove-leads/${getParams(params)}`, data),

  // inserting leads
  generateLeadsTemplate: () =>
    API.get<BlobPart>('crm-lead-excel/generate-leads-template', {
      responseType: 'arraybuffer',
    }),
  insertLeadsExcel: (formData: FormData) =>
    API.post<EmptyResponse>('crm-lead-excel/insert-leads-excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  insertLead: (data: RequestCreateLead) =>
    API.post<EmptyResponse>('crm-lead/insert-lead', data),

  getAllLeadStatuses: (
    params: { lead_id: number }, // с сортировкой, сначала новые
  ) =>
    API.get<ResponseLeadStatuses>(
      `crm-lead-status-history/get-all-lead-statuses/${getParams(params)}`,
    ),
  insertLeadStatus: (params: { lead_id: number; status_id: number }) =>
    API.post<EmptyResponse>(
      `crm-lead-status-history/insert-lead-status/${getParams(params)}`,
    ),
  deleteLeadStatus: (params: { status_history_id: number }) =>
    API.post<EmptyResponse>(
      `crm-lead-status-history/delete-lead-status/${getParams(params)}`,
    ),

  sendNotification: (params: { lead_id: number; notification_id: number }) =>
    API.post<EmptyResponse>(`crm/send-notification/${getParams(params)}`),

  getLeadHistory: (
    params: { lead_id: number; paramsPagination: PaginationParam }, // с сортировкой, сначала новые
  ) =>
    API.get<ResponseLeadHistory>(
      `crm-lead-history/get-lead-history/${getParams(params)}`,
    ),

  deleteStudAccount: (params: { lead_id: number }) =>
    API.post<EmptyResponse>(
      `crm-lead/delete-student-account/${getParams(params)}`,
    ),
  bindingStudAccount: (params: { lead_id: number; user_id: number }) =>
    API.post<EmptyResponse>(
      `crm-lead/binding-student-account/${getParams(params)}`,
    ),

  searchLeadsForSelect: (params: {
    filter: string[]
    paramsPagination: PaginationParam
  }) => API.get(`crm-lead/search-for-select/${getParams(params)}`),

  //--- Оплаты ---
  getLeadPayments: (params: { user_id: number }) =>
    API.get<ResponseLeadPayments>(`crm-lead-payment/get-lead-payments/${getParams(params)}`),

  //--- Ссылки на оплаты ---

  getLeadPaymentLinks: (params: {
    lead_id: number
    paramsPagination: PaginationParam
  }) =>
    API.get<ResponseLeadPaymentLinks>(
      `crm-lead-payment-link/get-links/${getParams(params)}`,
    ),
  getLeadPaymentLink: (link_id: number) =>
    API.get<ResponseLeadPaymentLink>(`crm-lead-payment-link/get-link/${link_id}`),
  createLeadPaymentLink: (data: RequestCreateLeadPaymentLink) =>
    API.post<EmptyResponse>('crm-lead-payment-link/create-link', data),
  deleteLeadPaymentLink: (link_id: number) =>
    API.post<EmptyResponse>(`crm-lead-payment-link/delete-link/${link_id}`),
  
  //-------- CRM settings (только РОП и админ) ---------

  // обновление сущесвующих статусов
  updateStatus: (data: RequestUpdateStatuses) =>
    API.put<EmptyResponse>('crm/update-status', data),
  updateStatuses: (data: RequestUpdateStatuses) =>
    API.put<EmptyResponse>('crm-lead-status/update-statuses', data),

  insertStatus: (data: RequestCreateStatus) =>
    API.post<EmptyResponse>('crm-lead-status/insert-status', data),
  deleteStatus: (id: number) =>
    API.post<EmptyResponse>(`crm-lead-status/post-delete?id=${id}`),

  // проверка что статус не использовался и его можно изменить/удалить
  checkStatusIsUnused: (id: number) =>
    API.get<ResponseCheckIsUnused>(
      `crm-lead-status/check-status-is-unused?id=${id}`,
    ),
  updateStatusesSorting: (data: RequestUpdateItemsSorting) =>
    API.put<EmptyResponse>('crm-lead-status/update-statuses-sorting', data),

  insertField: (data: RequestCreateField) =>
    API.post<EmptyResponse>('crm-lead-field/insert-field', data),
  updateField: (id: number, data: RequestUpdateField) =>
    API.patch<EmptyResponse>(`crm-lead-field/update-field?id=${id}`, data),
  deleteField: (id: number) =>
    API.post<EmptyResponse>(`crm-lead-field/post-delete?id=${id}`),

  // проверка что поле не использовалось в анкетах (лидах), и его можно изменить/удалить
  checkFieldIsUnused: (id: number) =>
    API.get<ResponseCheckIsUnused>(
      `crm-lead-field/check-field-is-unused?id=${id}`,
    ),
  updateFieldsSorting: (data: RequestUpdateItemsSorting) =>
    API.put<EmptyResponse>('crm-lead-field/update-fields-sorting', data),

  //--- Уведомления ---
  getNotifications: (params: {
    type: CRMNotificationType
    paramsPagination: PaginationParam
  }) =>
    API.get<ResponseNotifications>(
      `crm/get-notifications/${getParams(params)}`,
    ),
  getAllNotifications: (params: { type: CRMNotificationType }) =>
    API.get<ResponseNotifications>(
      `crm/get-all-notifications/${getParams(params)}`,
    ),
  getNotification: (id: number) =>
    API.get<ResponseNotification>(`crm/get-notification?id=${id}`),

  insertNotification: (data: RequestCreateNotification) =>
    API.post<EmptyResponse>('crm/insert-notification', data),
  updateNotification: (id: number, data: RequestUpdateNotification) =>
    API.patch<EmptyResponse>(`crm/update-notification?id=${id}`, data),
  updateNotificationsSorting: (data: RequestUpdateItemsSorting) =>
    API.put<EmptyResponse>('crm/update-notifications-sorting', data),

  insertTrigger: (data: RequestCreateTrigger) =>
    API.post<EmptyResponse>('crm/insert-notification-trigger', data),
  updateTrigger: (id: number, data: RequestUpdateTrigger) =>
    API.patch<EmptyResponse>(`crm/update-notification-trigger?id=${id}`, data),

  deleteNotification: (params: { id: number; remove_trigger?: boolean }) =>
    API.post<EmptyResponse>(`crm/delete-notification/${getParams(params)}`),

  //--- Автоматизация ---

  getAllAutomations: () =>
    API.get<ResponseAutomations>('crm-automation/get-all-automations'),

  insertAutomation: (data: RequestCreateAutomation) =>
    API.post<EmptyResponse>('crm-automation/insert-automation', data),
  updateAutomation: (id: number, data: RequestUpdateAutomation) =>
    API.patch<EmptyResponse>(
      `crm-automation/update-automation?id=${id}`,
      data,
    ),
  deleteAutomation: (id: number) =>
    API.post<EmptyResponse>(`crm-automation/delete-automation?id=${id}`),

  updateAutomationsSorting: (data: RequestUpdateItemsSorting) =>
    API.put<EmptyResponse>('crm-automation/update-automations-sorting', data),
}
